module.exports = __webpack_public_path__ + "static/shifts-dashboard-6e4ca4c996ce4485f1b9863ac2eb3f78.png";